import { OnDestroy } from '@angular/core';
import { _Constructor as Constructor } from '@angular/material/core';
import { Subject } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export function WithDisposableSubject<T extends Constructor<{}>>(Base: T = (class { } as any)) {
  return class extends Base implements OnDestroy {
    disposer = new Subject<any>();

    ngOnDestroy() {
      this.disposer.next(null);
      this.disposer.complete();
    }
  };

}
